import { Stack, Typography } from '@mui/material'
import { YALO_SEMANTIC } from '@commerce/tokens'

export interface LabelledRowProps {
  label: string
  value: string
  /** Overrides both sides — used for the one line that is money saved. */
  color?: string
  /** The line that carries the total, or the one the eye should land on. */
  strong?: boolean
}

/**
 * A label on the left, a value on the right: subtotal, discount, shipping,
 * total, delivery date, payment method, order number.
 *
 * Three screens grew their own copy of this — `TotalsRow` on the cart,
 * `SummaryRow` on payment, and the confirmation importing the latter *from the
 * payment page*, which is how a receipt ends up depending on a checkout form.
 * Two of those agents flagged it in the same breath as writing it.
 *
 * `component="span"` is the part worth keeping. MUI maps `subtitle1` onto an
 * `<h6>`, and neither a total nor an order number is a heading — without this,
 * a screen reader listing the page's headings finds the whole receipt among
 * them.
 */
export const LabelledRow = ({ label, value, color, strong }: LabelledRowProps) => (
  <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={2}>
    <Typography
      component="span"
      variant={strong ? 'subtitle1' : 'body2'}
      sx={{ fontWeight: strong ? 700 : 400, color: color ?? YALO_SEMANTIC.fg3 }}
    >
      {label}
    </Typography>
    <Typography
      component="span"
      variant={strong ? 'subtitle1' : 'body2'}
      sx={{
        fontWeight: strong ? 700 : 600,
        color: color ?? 'text.primary',
        textAlign: 'right',
      }}
    >
      {value}
    </Typography>
  </Stack>
)
